import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { parseMessages } from 'helpers/parse-dll-error'
import { prepareData } from 'helpers/prepare-req-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    loadOwnListStatus: 'idle',
    loadOwnListError: undefined as any,
    loadOwnListLastParams: undefined as string | undefined,
    createOwnStatus: 'idle',
    createOwnError: undefined as any,
    updateOwnStatus: 'idle',
    updateOwnError: undefined as any,
    deleteOwnStatus: 'idle',
    deleteOwnError: undefined as any,

    ownList: [] as any[],
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false
}
export const loadOwnList = createAsyncThunk('ownSlice/loadOwnList', async ({ forceReload=false }: any, { rejectWithValue, getState }: any) => {
    const { loadOwnListLastParams } = getState().ownSlice
    const url = `/api/ixweb/own/`

    let _allParams: any = new URLSearchParams(url.split('?')[1])
    _allParams.sort()
    _allParams = _allParams.toString()

    if (_allParams === loadOwnListLastParams && !forceReload) {
        return
    }

    const res = await client.get(
        url,
        {
        })

    // check type of response -  winrest or backend
    if (typeof(res.data) === 'object' && res.data.hasOwnProperty('status')) {  // winrest response
        if (res.data.status === 'Failed') {
            return rejectWithValue(parseMessages(res.data.messages))
        } else {
            return { data: res.data.data, params: _allParams }
        }
    } else {  // backend response
        return { data: res.data, params: _allParams }
    }
},
{
    condition: (_, { getState }) => {
        const state = getState() as any
        const reducerStatus = state.ownSlice.loadOwnListStatus
        return reducerStatus !== 'preloaded'
    }
})
export const createOwn = createAsyncThunk('ownSlice/createOwn', async (own: any, { rejectWithValue, getState }: any) => {
    const url = `/api/ixweb/own/`


    const reducerStatus = (getState() as any).ownSlice.loadOwnListStatus
    let res: any = {}
    if (reducerStatus === 'preloaded') {
        res = own
    } else {
        res = await client.post(url, prepareData(own))
    }

    // check type of response -  winrest or backend
    if (typeof(res.data) === 'object' && res.data.hasOwnProperty('status')) {  // winrest response
        if (res.data.status === 'Failed') {
            return rejectWithValue(parseMessages(res.data.messages))
        } else {
            return { ...own, HDR_ID: res.data.data.id }
        }
    } else {  // backend response
        return res.data
    }
})
export const updateOwn = createAsyncThunk('ownSlice/updateOwn', async (own: any, { rejectWithValue, getState }: any) => {
    const url = `/api/ixweb/own/${own.HDR_ID}/`


    const reducerStatus = (getState() as any).ownSlice.loadOwnListStatus
    let res: any = {}
    if (reducerStatus === 'preloaded') {
        res = own
    } else {
        res = await client.put(url, prepareData(own))
    }

    // check type of response -  winrest or backend
    if (typeof(res.data) === 'object' && res.data.hasOwnProperty('status')) {  // winrest response
        if (res.data.status === 'Failed') {
            return rejectWithValue(parseMessages(res.data.messages))
        } else {
            return own
        }
    } else {  // backend response
        return res.data
    }
})
export const deleteOwn = createAsyncThunk('ownSlice/deleteOwn', async (id: any, { rejectWithValue, getState }: any) => {
    const url = `/api/ixweb/own/${id}/`


    const reducerStatus = (getState() as any).ownSlice.loadOwnListStatus
    let res: any = {}
    if (reducerStatus !== 'preloaded') {
        res = await client.delete(
            url,
            {
            }
        )
    }

    // check type of response -  winrest or backend
    if (typeof(res.data) === 'object' && res.data.hasOwnProperty('status')) {  // winrest response
        if (res.data.status === 'Failed') {
            return rejectWithValue(parseMessages(res.data.messages))
        } else {
            return id
        }
    } else {  // backend response
        return id
    }
})

const OwnSlice = createSlice({
    name: 'ownSlice',
    initialState,
    reducers: {
        resetloadOwnListError: (state) => {
            state.loadOwnListError = undefined
        },
        resetcreateOwnError: (state) => {
            state.createOwnError = undefined
        },
        resetupdateOwnError: (state) => {
            state.updateOwnError = undefined
        },
        resetdeleteOwnError: (state) => {
            state.deleteOwnError = undefined
        },
        removeFromOwnListById: (state, action) => {
            state.ownList = state.ownList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        preloadData: (state, action) => {
            state.ownList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.loadOwnListStatus = 'preloaded'
            state.loadOwnListLastParams = ''
        },
        clearPreloadedData: (state) => {
            state.ownList = []
            state.loadOwnListStatus = 'idle'
            state.loadOwnListLastParams = undefined
        },
    },
    extraReducers: builder => {
        builder.addCase(loadOwnList.pending, (state) => {
            state.loadOwnListStatus = 'pending'
            state.loadOwnListError = undefined
        })
        builder.addCase(loadOwnList.fulfilled, (state, action) => {
            state.loadOwnListStatus = 'idle'

            if (!action.payload) { return }

            state.loadOwnListLastParams = action.payload.params

            state.ownList = action.payload.data
        })
        builder.addCase(loadOwnList.rejected, (state, action) => {
            state.loadOwnListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadOwnListError = action.error.message
            } else {
                state.loadOwnListError = action.payload
            }
        })

        builder.addCase(createOwn.pending, (state) => {
            state.createOwnStatus = 'pending'
            state.createOwnError = undefined
        })
        builder.addCase(createOwn.fulfilled, (state, action) => {
            state.createOwnStatus = 'idle'


            state.ownList = [...state.ownList, Array.isArray(action.payload) ? action.payload[0] : action.payload]
        })
        builder.addCase(createOwn.rejected, (state, action) => {
            state.createOwnStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.createOwnError = action.error.message
            } else {
                state.createOwnError = action.payload
            }
        })

        builder.addCase(updateOwn.pending, (state) => {
            state.updateOwnStatus = 'pending'
            state.updateOwnError = undefined
        })
        builder.addCase(updateOwn.fulfilled, (state, action) => {
            state.updateOwnStatus = 'idle'


            let updatedItems = Array.isArray(action.payload) ? action.payload : [action.payload]
            for (let updatedItem of updatedItems) {
                const i = state.ownList.findIndex((x: any) => x.HDR_ID === updatedItem.HDR_ID)
                if (i === -1) { state.ownList.push(updatedItem) }
                else { state.ownList[i] = { ...state.ownList[i], ...updatedItem } }
            }
        })
        builder.addCase(updateOwn.rejected, (state, action) => {
            state.updateOwnStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.updateOwnError = action.error.message
            } else {
                state.updateOwnError = action.payload
            }
        })

        builder.addCase(deleteOwn.pending, (state) => {
            state.deleteOwnStatus = 'pending'
            state.deleteOwnError = undefined
        })
        builder.addCase(deleteOwn.fulfilled, (state, action) => {
            state.deleteOwnStatus = 'idle'


            if (Array.isArray(action.payload)) {
                state.ownList = state.ownList.filter((x: any) => !action.payload.includes(x.HDR_ID))
            } else {
                state.ownList = state.ownList.filter((x: any) => x.HDR_ID !== action.payload)
            }
        })
        builder.addCase(deleteOwn.rejected, (state, action) => {
            state.deleteOwnStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.deleteOwnError = action.error.message
            } else {
                state.deleteOwnError = action.payload
            }
        })

    }
})

export const {
    resetloadOwnListError,
    resetcreateOwnError,
    resetupdateOwnError,
    resetdeleteOwnError,
    removeFromOwnListById,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    preloadData,
    clearPreloadedData,
} = OwnSlice.actions
export default OwnSlice.reducer
